import React, { Component } from 'react';
import Registry from "../../../Utils/Registry";
import { Button, Label, Input, Col, Row } from 'reactstrap';
import TYSelect from "../../TYSelect";
import TYCheckBox from "../../TYCheckBox";
import TYItem from "../../TYItem";
import {NotificationManager} from "react-notifications";
import Vars from '../../../Utils/Variables';

const { energies } = Vars;
const days = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
const convertTable = { int: parseInt, float: parseFloat };

class OperationsFleetBaseForm extends Component {
    constructor(props){
        super(props);

        this.state = {
            model: "",
            color: "",
            plate: "",
            gas: "",
            energy_type: 0,
            energy_sub_type: 0,
            fleet_category: "",
            fleet_categories: [],
            fleet: [],
            gas_list: [],
            applyToRec: false,
            loadingRecs: false,
            recIdToApply: [],
            recList: [],
            errors: {
                model: false,
                plate: false,
                gas: false,
                color: false,
                fleet_category: false
            },
            loading: false
        };

        this.api = Registry.registered("api");

        this.inputChanged = this.inputChanged.bind(this);
        this.addVehicle = this.addVehicle.bind(this);
        this.onActivityChanged = this.onActivityChanged.bind(this);
    }

    inputChanged(e, input_key, convertType=undefined){
        if(this.state.hasOwnProperty(input_key)){
            let nState = this.state;
            let value = (typeof e === "string" ? e : e.target.value);
            if(convertType && convertTable[convertType])
                value = convertTable[convertType](value);
            nState[input_key] = value;
            nState.errors[input_key] = false;
            this.setState(nState);
        }
    }

    toggleApplyToRec = () => this.setState({applyToRec: !this.state.applyToRec}, () => {
        if(this.state.applyToRec)
            this.loadRecList();
    });

    loadRecList = () => {
        this.setState({loadingRecs: true, recList: []});
        this.api.get("/recurrent?per_page=1000000000")
            .then(results => {
                this.setState({recList: results.results, loadingRecs: false});
            })
            .catch(_ => {
                this.setState({loadingRecs: false});
                NotificationManager.error("Impossible de charger les recurrences");
            })
    };

    toggleRec(id){
        let tmp = this.state.recIdToApply.slice();
        let i = tmp.indexOf(id);
        if(i === -1)
            tmp.push(id);
        else 
            tmp.splice(i, 1);
        this.setState({recIdToApply: tmp});
    }

    addVehicle(){
        let valid = true;

        for (let k in this.state.errors) {
            if (this.state.errors.hasOwnProperty(k) && this.state[k] === "") {
                if(k !== "gas" || this.state.energy_type !== 1){
                    let nState = this.state;
                    nState.errors[k] = true;
                    this.setState(nState);
                    valid = false;
                }
            }
        }

        if(valid){
            this.setState({loading: true});

            this.api.post("/fleet?type=business", {
                description: this.state.model,
                plate: this.state.plate,
                energy_type: this.state.energy_type,
                energy_sub_type: this.state.energy_sub_type,
                color: this.state.color,
                gas_id: this.state.energy_type === 0 ? this.state.gas : undefined,
                category: this.state.fleet_category,
                apply_to_rec: this.state.applyToRec,
                recurrence_ids: this.state.recIdToApply.join(",")
            })
                .then(_ => {
                    this.setState({loading: false}, () => {
                        this.props.newVehicleAdded();
                        NotificationManager.success("Le véhicule a bien été ajouté à votre flotte");
                    });
                })
                .catch(({subcode}) => {
                    let errMsg = "Une erreur est survenue. Merci de bien vouloir réessayer";
                    
                    switch(subcode) {
                        case "POSTFleetPlateExists":
                            errMsg = "Un véhicule avec cette plaque est déjà present dans votre";
                            break;
                        case "POSTFleetRequestEmpty":
                            errMsg = "Merci de remplir les information";
                            break;
                        case "POSTFleetMissingDescription":
                            errMsg = "Veuillez renseigner une description";
                            break;
                        case "POSTFleetMissingGasId":
                            errMsg = "Veuillez renseigner le type de carburant";
                            break;
                        case "POSTFleetMissingPlate":
                            errMsg = "Veuillez renseigner une plaque ou un numero d'identification";
                            break;
                        case "POSTFleetMissingColor":
                            errMsg = "Veuillez renseigner une couleur";
                            break;
                    }

                    this.setState({loading: false}, () => {
                        NotificationManager.error(errMsg);
                    });
                })
        }
    }

    onActivityChanged(category){
        this.setState({fleet_category: category});
    }

    componentDidMount(){
        this.api.get("/fleet/categories?type=business")
            .then(result => {
                let categories = [];
                for (let cat of result.results)
                    categories.push(cat.category);
                this.setState({fleet_categories: categories});
            });
    }

    render(){
        return (
            <div>
                { this.props.showTitle ? <h2 className="ty-subtitle">Ajouter un v&eacute;hicule &agrave; votre flotte</h2> : "" }

                <div className={this.props.tyBlock ? "ty-block" : "marg-b-15"}>
                    <Row className="marg-b-10">
                        <Col xs="12" sm="6" className="marg-xs-b-10">
                            <Label for="car_model" className="bold" style={this.state.errors.model ? {color: "red"}:{}}>
                                Modele *
                            </Label>
                            <Input placeholder="Ex: Citroen C3" onChange={e => this.inputChanged(e, "model")} />
                        </Col>
                        <Col xs="12" sm="6" className="marg-xs-b-10">
                            <Label for="car_plate" className="bold" style={this.state.errors.plate ? {color: "red"}:{}}>
                                Plaque d'immatriculation *
                            </Label>
                            <Input placeholder="TY-XXX-12" onChange={e => this.inputChanged(e, "plate")}/>
                        </Col>
                    </Row>
                    <Row className="marg-b-10">
                        <Col xs="12" sm="6">
                            <Label for="gas_select" className="bold" style={this.state.errors.energy_type ? {color: "red"}:{}}>Type d'énérgie *</Label>
                            <Input type="select" name="select_energy_type" onChange={e => this.inputChanged(e, "energy_type", "int")} value={this.state.energy_type}>
                                <option value="">S&eacute;l&eacute;ctionner un type d'énérgie</option>
                                { energies.map(({ label, value }) => <option key={"energy-" + value} value={value}>{ label }</option>) }
                            </Input>
                        </Col>
                        
                        {
                            this.state.energy_type === 0 ?
                                <Col xs="12" sm="6">
                                    <Label for="gas_select" className="bold" style={this.state.errors.gas ? {color: "red"}:{}}>Carburant *</Label>
                                    <Input type="select" name="select_gas" onChange={e => this.inputChanged(e, "gas")}>
                                        <option value="">S&eacute;l&eacute;ctionner un carburant</option>
                                        {
                                            this.props.gas_list.map((gas, i) => {
                                                return <option key={"gas-" + i} value={gas.id}>{ gas.name }</option>;
                                            })
                                        }
                                    </Input>
                                </Col>
                                :
                                <Col xs="12" sm="6">
                                    <Label for="gas_select" className="bold" style={this.state.errors.energy_sub_type ? {color: "red"}:{}}>Sous type *</Label>
                                    <Input type="select" name="select_energy_sub_type" onChange={e => this.inputChanged(e, "energy_sub_type", "int")}>
                                        <option value="">S&eacute;l&eacute;ctionner un sous type</option>
                                        { energies[this.state.energy_type].subTypes.map(({value, label}) => <option key={"subtype-" + value} value={value}>{ label }</option>) }
                                    </Input>
                                </Col>
                        }
                    </Row>
                    <Row>
                        <Col xs="12" sm="6">
                            <Label for="color_select" className="bold" style={this.state.errors.color ? {color: "red"}:{}}>
                                Couleur *
                            </Label>
                            <Input type="select" name="select_color" onChange={e => this.inputChanged(e, "color")}>
                                <option value="">S&eacute;l&eacute;ctionner une couleur</option>
                                <option value="Blanc">Blanc</option>
                                <option value="Noir">Noir</option>
                                <option value="Gris">Gris</option>
                                <option value="Jaune">Jaune</option>
                                <option value="Rouge">Rouge</option>
                                <option value="Bleu">Bleu</option>
                                <option value="Vert">Vert</option>
                                <option value="Orange">Orange</option>
                                <option value="Violet">Violet</option>
                            </Input>
                        </Col>

                        <Col xs="12" sm="6">
                            <Label for="fleet_select" className="bold" style={this.state.errors.fleet_category ? {color: "red"}:{}}>Flotte *</Label>
                            <TYSelect
                                items={this.state.fleet_categories}
                                selected={this.state.fleet_category}
                                otherActive={true}
                                itemClicked={this.onActivityChanged}
                                onOtherValueChanged={this.onActivityChanged}
                                otherPlaceholder="Ajouter une flotte ..."
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-flex marg-t-20">
                                <TYCheckBox onToggle={this.toggleApplyToRec} />
                                <p className="bold marg-l-10">Ajouter aussi aux commandes recurrente</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {
                                this.state.recList.map((r, i) => {
                                    return <TYItem className={"rec-" + i}>
                                        <div className="d-flex">
                                            <div className="d-flex align-items-center">
                                                <TYCheckBox onToggle={() => { this.toggleRec(r.id); }} />
                                            </div>
                                            <div style={{flex: 2}} className="pad-10">
                                                { r.weekdays_repeat.split(",").map(i => days[i]).join(", ") }<br />
                                                { r.location }
                                            </div>
                                            <div className="bold d-flex align-items-center">
                                                { r.recurrent_hour }
                                            </div>
                                        </div>
                                    </TYItem>;
                                })
                            }
                        </Col>
                    </Row>
                </div>
                <div className="center">
                    <Button className="text-uppercase" color="primary" onClick={this.addVehicle}>
                        {
                            this.state.loading ?
                                <i className="icon icon-loading animated spin infinite f-18"> </i>
                                : "Enregistrer les informations"
                        }
                    </Button>
                </div>
            </div>
        );
    }

}

OperationsFleetBaseForm.defaultProps = {
    newVehicleAdded: () => {},
    tyBlock: true,
    showTitle: true,
    gas_list: []
};

export default OperationsFleetBaseForm;



// WEBPACK FOOTER //
// ./src/components/Operations/Fleet/BaseForm.js